var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSymbols(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 323.7 500",
    style: {
      enableBackground: "new 0 0 323.7 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#010101;stroke-width:25;stroke-linecap:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ampersand"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "282.4,425.6 204.782,350.521 137.314,276.711 106.609,239.845 80.005,204.786 71.008,191.582 64.753,181.352 59.084,170.778 55.722,163.521 52.763,156.091 50.275,148.489 48.322,140.734 46.903,132.863 45.98,124.918 45.511,116.933 45.567,104.937 46.442,92.971 47.551,85.051 49.19,77.22 51.46,69.553 52.864,65.809 54.465,62.144 56.273,58.577 58.293,55.12 60.51,51.79 62.916,48.595 65.5,45.541 68.251,42.638 71.159,39.892 74.215,37.31 77.407,34.901 80.725,32.673 84.159,30.631 87.706,28.782 91.349,27.133 95.078,25.687 98.881,24.447 102.747,23.418 106.662,22.604 110.617,22.011 114.6,21.644 118.598,21.51 122.596,21.617 126.579,21.972 130.531,22.581 134.436,23.444 138.279,24.553 142.044,25.901 145.719,27.478 149.291,29.274 152.752,31.278 156.093,33.479 159.302,35.864 162.375,38.422 165.307,41.142 170.76,46.994 175.728,53.259 182.479,63.179 194.535,83.936 203.615,101.758 209.985,116.414 214.104,127.683 217.59,139.162 220.396,150.827 222.467,162.644 223.402,170.588 223.929,178.57 223.996,186.568 223.55,194.553 222.54,202.486 220.925,210.308 218.715,217.979 215.94,225.477 212.633,232.768 208.824,239.817 204.551,246.584 199.835,253.04 194.702,259.177 186.39,267.818 174.556,278.553 79.559,351.89 70.465,359.701 61.806,368.002 53.691,376.839 48.639,383.039 43.915,389.494 39.562,396.205 35.631,403.17 32.207,410.4 29.425,417.898 28.327,421.74 27.458,425.647 26.849,429.6 26.53,433.585 26.534,437.583 26.883,441.568 27.578,445.506 28.617,449.366 29.998,453.121 31.718,456.731 33.772,460.16 36.158,463.371 38.862,466.315 41.871,468.948 45.156,471.224 48.676,473.122 52.369,474.658 56.179,475.861 60.074,476.767 64.026,477.408 68.004,477.812 75.998,478.01 83.984,477.523 91.91,476.456 99.75,474.875 107.484,472.834 118.861,469.031 129.964,464.482 140.771,459.318 151.306,453.571 164.883,445.08 177.868,435.733 190.221,425.576 201.899,414.645 212.857,403.0 225.649,387.634 237.662,371.724 242.075,365.013 247.904,354.691 256.524,336.726 281.572,273.678 303.1,213.0 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "asterisk"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "90.5,15.7 104.9,177.1 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "18.9,38.0 156.7,164.6 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "25.1,164.6 147.1,36.9 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "slash"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 23.6,
    y1: 475.6,
    x2: 318,
    y2: 24.4
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "at"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "256.2,168.4 243.1,150.6 222.9,138.2 199,138.2 166.5,146.7 134.8,168.4 117.7,190.8 113.1,215.6 113.1,243.4 123.9,269.7 151.8,287.5 193.5,276.7 219.1,246.5 239.2,217.9 253.1,188.5 "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "256.2,162.2 250,241.9 250,269 260.1,292.9 275.6,307.6 298.8,318.5 325.1,318.5 350.6,297.6 363.8,267.4 371.5,227.2 371.5,187.7 350.6,125.1 316.6,86.4 280.2,60.1 239.2,43 197.4,33.8 159.5,33.8 122.4,43 95.3,61.6 72.1,85.6 45.8,125.1 24.9,176.1 16.4,217.1 16.4,268.2 34.2,333.2 52.7,368 82.9,399.7 122.4,433 159.5,452.4 212.9,466.2 274.8,462.4 320.4,452.4 364.5,429.9 393.9,405.1 447.3,333.9 "
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "bracketleft"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "213.7,31.3 129.925,26.441 98.176,26.029 82.351,26.635 74.414,27.353 66.594,28.547 62.776,29.414 59.057,30.543 55.353,32.094 51.953,34.112 48.917,36.634 46.25,39.572 44.052,42.86 42.334,46.423 41.018,50.16 40.0,54.006 38.553,61.814 36.488,81.535 23.452,356.032 23.332,387.815 23.9,399.745 24.717,407.65 25.336,411.557 26.15,415.402 27.23,419.214 28.645,422.936 30.435,426.481 32.609,429.808 35.101,432.897 37.851,435.749 40.892,438.335 44.102,440.602 47.433,442.618 54.513,446.211 65.653,450.835 91.851,459.641 195.9,487.3 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "bracketright"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "18.1,18.6 117.243,34.511 156.383,42.601 179.479,48.528 194.305,53.142 205.822,57.428 212.857,60.491 220.214,64.212 226.795,68.178 230.214,70.569 233.349,73.027 236.213,75.557 239.065,78.425 241.684,81.464 244.018,84.612 246.136,87.965 248.012,91.481 249.645,95.136 251.017,98.816 253.2,106.534 254.704,114.246 256.588,130.072 260.773,221.903 260.229,357.703 258.34,401.767 257.311,413.667 256.2,421.412 255.397,425.434 254.419,429.318 253.255,433.012 251.769,436.772 250.0,440.344 247.931,443.699 245.54,446.832 242.794,449.754 239.799,452.363 236.671,454.621 233.197,456.717 229.559,458.557 226.112,460.041 218.383,462.685 210.912,464.59 202.999,466.118 187.392,468.12 163.557,469.56 119.453,469.515 23.3,464.4 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "colon"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "47.2,149.1 38.5,182.1 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "47.2,374.7 38.5,407.7 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "comma"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "53.3,374.1 32.4,485.3 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "dollar"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "124.1,10.1 112.199,472.501 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "232.9,91.7 223.033,84.762 216.279,80.548 209.293,76.687 202.061,73.26 194.592,70.368 186.928,68.122 179.129,66.613 171.143,65.873 163.168,65.886 151.234,66.938 139.387,68.782 127.707,71.454 120.044,73.723 108.784,77.833 97.835,82.712 90.761,86.435 83.939,90.6 77.448,95.259 71.384,100.463 68.548,103.28 65.863,106.241 63.343,109.342 61.007,112.583 58.874,115.967 56.976,119.486 55.35,123.134 54.034,126.906 53.079,130.789 52.541,134.746 52.472,138.738 52.901,142.708 53.792,146.603 55.088,150.381 56.729,154.022 58.663,157.522 60.842,160.875 63.225,164.08 68.494,170.089 74.286,175.598 80.474,180.653 86.962,185.322 97.084,191.747 139.077,214.908 149.262,221.23 159.034,228.174 168.351,235.718 177.204,243.802 185.592,252.367 193.48,261.396 198.395,267.699 202.977,274.248 207.165,281.054 210.896,288.122 214.104,295.442 216.737,302.987 218.733,310.726 220.023,318.612 220.379,322.592 220.53,326.585 220.467,330.581 220.181,334.568 219.668,338.532 218.922,342.457 217.934,346.33 216.693,350.131 215.19,353.834 213.415,357.411 211.355,360.837 209.007,364.07 206.369,367.07 203.451,369.798 200.289,372.238 196.924,374.393 193.394,376.273 189.741,377.886 185.987,379.253 182.154,380.388 178.262,381.306 170.368,382.543 162.395,383.055 154.402,382.934 146.439,382.304 130.626,380.015 107.13,375.33 91.651,371.422 72.588,365.505 42.652,354.274 35.2,351.2 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "ellipsis"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "50.2,446.0 37.9,476.4 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "172.7,446.0 172.7,476.4 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "307.5,443.4 307.5,476.4 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "emdash"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "33.8,233.3 335.0,233.3 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "endash"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "33.8,233.3 288.9,233.3 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "equal"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "31.8,194.5 288.7,194.5 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "31.8,332.6 324.6,332.6 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "euro"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "17.0,160.3 316.4,173.5 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "41.4,280.8 293.8,280.8 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "429.5,49.2 414.968,42.35 403.922,37.94 396.36,35.381 388.653,33.206 380.827,31.49 372.931,30.306 365.005,29.706 357.0,29.7 349.041,30.235 337.169,31.737 325.399,33.955 313.785,36.899 298.588,41.803 279.975,49.032 265.429,55.617 251.236,62.952 237.498,71.098 227.587,77.828 218.111,85.156 209.164,93.124 200.796,101.69 193.017,110.797 185.837,120.39 179.256,130.4 171.305,144.252 162.423,162.134 156.073,176.79 152.002,188.057 149.75,195.719 147.955,203.5 146.675,211.383 145.882,219.329 145.501,231.302 145.937,243.274 147.535,259.166 150.15,274.922 153.744,290.485 158.291,305.796 162.353,317.066 167.011,328.103 172.295,338.854 178.205,349.274 186.919,362.66 198.862,378.659 209.154,390.874 217.437,399.528 223.285,404.967 229.422,410.077 235.852,414.813 245.943,421.267 256.429,427.06 274.446,435.66 292.893,443.278 311.747,449.877 327.087,454.309 342.671,457.781 358.446,460.249 378.301,462.105 450.2,463.6 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "exclam"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "61.4,15.6 44.0,386.3 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "44.0,440.8 44.0,471.3 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "guillemotleft"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "268.5,159.2 91.962,244.277 70.657,255.717 60.558,261.804 54.102,266.355 50.955,269.037 48.248,271.929 46.062,275.191 44.483,278.82 43.935,282.752 44.644,286.616 46.173,290.162 48.301,293.655 50.581,296.749 55.764,302.725 64.249,311.12 82.467,326.898 149.436,377.42 225.1,430.3 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "293.7,208.7 253.257,234.794 233.835,248.717 224.503,256.186 218.565,261.471 212.996,267.155 210.51,270.118 208.157,273.401 206.191,276.883 204.777,280.581 204.107,284.478 204.29,288.434 205.227,292.293 206.805,295.938 208.874,299.309 211.277,302.442 213.941,305.434 219.609,310.963 231.807,321.237 302.8,373.1 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "guillemotright"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "27.6,183.8 99.089,234.117 120.984,251.113 132.713,261.325 138.367,266.943 141.099,269.994 143.484,272.987 145.717,276.298 147.542,279.818 148.78,283.54 149.314,287.425 149.187,291.355 148.403,295.205 147.019,298.863 145.193,302.333 142.998,305.739 138.212,311.959 130.357,320.689 107.539,342.762 35.8,405.4 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "102.2,140.2 212.539,226.443 236.641,246.976 248.342,257.92 253.775,263.537 258.907,269.546 261.304,272.837 263.364,276.215 264.994,279.749 266.071,283.55 266.481,287.509 266.281,291.486 265.413,295.361 264.018,298.983 262.222,302.485 260.078,305.988 255.489,312.413 245.368,324.571 117.5,450.8 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "parenleft"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "95.9,20.0 76.894,45.555 65.947,62.062 57.933,75.776 50.828,89.952 44.559,104.558 39.124,119.477 34.602,134.7 30.089,154.034 26.005,177.51 23.107,201.16 21.722,220.967 21.512,236.85 22.224,252.716 23.875,268.513 26.472,284.187 30.937,303.533 37.707,326.374 54.155,371.1 65.028,396.677 75.496,418.066 81.388,428.429 87.917,438.374 95.063,447.933 105.316,460.062 118.969,474.402 124.7,480.0 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "parenright"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "73.7,22.1 87.077,46.597 95.709,64.626 101.742,79.371 106.813,94.477 111.979,113.711 116.067,133.221 119.599,156.872 121.902,180.682 122.85,204.584 122.428,228.504 120.424,256.344 115.887,291.939 108.007,335.083 101.608,362.248 95.957,381.363 90.497,396.348 84.077,410.939 78.669,421.614 74.717,428.515 70.339,435.168 65.518,441.517 60.278,447.551 54.73,453.226 45.823,461.253 36.499,468.659 23.4,477.9 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "percent"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "92.9,480.7 367.4,14.3 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "78.4,107.6 68.462,114.266 62.15,119.018 56.084,124.112 50.345,129.598 45.051,135.511 42.641,138.602 40.356,141.864 38.26,145.241 36.382,148.715 34.729,152.293 33.305,155.993 32.126,159.785 31.194,163.638 30.495,167.539 30.006,171.471 29.726,175.423 29.673,179.383 29.866,183.338 30.323,187.27 31.062,191.169 32.093,194.998 33.423,198.73 35.053,202.339 36.98,205.801 39.191,209.09 41.666,212.184 44.382,215.071 47.31,217.741 50.426,220.19 53.706,222.416 57.129,224.417 60.672,226.19 64.322,227.737 68.06,229.056 71.871,230.145 75.742,231.0 79.657,231.62 83.602,232.002 87.563,232.147 91.526,232.054 95.476,231.722 99.398,231.149 103.277,230.336 107.097,229.28 110.841,227.98 114.492,226.436 118.03,224.65 121.44,222.63 124.71,220.392 127.831,217.948 130.792,215.312 133.584,212.499 136.199,209.521 138.63,206.391 140.869,203.12 142.908,199.72 144.738,196.205 146.351,192.585 147.733,188.871 148.872,185.074 149.759,181.21 150.387,177.3 150.758,173.357 150.872,169.397 150.738,165.437 150.363,161.491 149.762,157.573 148.947,153.695 147.931,149.867 146.71,146.102 145.276,142.416 143.632,138.816 141.786,135.305 137.573,128.596 132.776,122.275 127.566,116.351 119.064,107.968 110.126,100.237 97.5,90.5 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "395.7,286.9 387.556,278.121 381.83,272.668 375.765,267.565 369.322,262.926 366.0,260.856 362.491,258.912 358.934,257.198 355.304,255.716 351.51,254.459 347.662,253.485 343.762,252.806 339.824,252.426 335.866,252.343 331.91,252.54 327.971,252.987 324.064,253.661 320.205,254.572 316.414,255.731 312.714,257.149 309.128,258.833 305.682,260.782 302.394,262.999 299.293,265.468 296.398,268.175 293.724,271.1 291.281,274.221 289.074,277.513 287.101,280.952 285.361,284.515 283.849,288.18 282.56,291.928 281.49,295.746 280.634,299.617 279.99,303.53 279.554,307.471 279.328,311.429 279.31,315.394 279.503,319.352 279.91,323.297 280.534,327.212 281.379,331.085 282.447,334.902 283.742,338.65 285.264,342.311 287.014,345.867 288.992,349.302 291.195,352.597 293.615,355.737 296.236,358.712 299.04,361.514 302.011,364.138 305.135,366.579 308.397,368.833 311.783,370.896 315.279,372.764 318.875,374.434 322.558,375.902 326.316,377.165 330.138,378.219 334.012,379.062 337.927,379.69 341.87,380.097 345.831,380.279 349.796,380.227 353.749,379.935 357.675,379.393 361.559,378.592 365.376,377.526 369.107,376.187 372.73,374.578 376.221,372.708 379.568,370.589 382.761,368.239 385.793,365.678 388.656,362.935 391.352,360.035 396.277,353.83 400.62,347.199 402.549,343.731 404.29,340.162 405.818,336.522 407.142,332.802 408.263,329.005 409.919,321.245 410.856,313.356 411.174,305.469 410.973,297.557 409.875,285.721 408.0,273.9 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "period"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "51.6,445.3 34.2,476.5 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "plus"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "151.1,122.2 151.1,406.3 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "26.9,250.6 307.8,250.6 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "question"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "24.2,52.4 41.551,42.398 55.856,35.261 66.869,30.638 74.455,27.982 82.117,25.795 89.94,24.11 97.836,22.961 105.796,22.286 113.786,22.098 121.765,22.506 129.669,23.628 133.572,24.491 137.421,25.569 141.199,26.867 144.895,28.386 148.495,30.12 151.993,32.05 158.686,36.417 164.993,41.326 170.961,46.643 179.408,55.152 187.37,64.117 194.748,73.566 199.258,80.164 203.377,87.013 207.047,94.113 210.228,101.445 212.886,108.983 214.981,116.695 216.47,124.548 217.306,132.495 217.456,140.486 216.906,148.458 215.639,156.349 213.641,164.086 210.898,171.591 207.419,178.785 203.282,185.621 198.573,192.078 193.372,198.147 187.752,203.829 181.775,209.137 172.299,216.478 159.031,225.395 128.412,244.272 118.621,251.19 112.421,256.234 106.575,261.684 101.151,267.553 96.227,273.848 91.893,280.561 89.975,284.068 88.241,287.667 86.695,291.352 84.161,298.93 82.315,306.699 81.056,314.591 80.035,326.536 79.793,338.509 80.094,346.485 80.82,354.469 82.641,366.327 85.183,377.998 89.45,393.405 95.8,412.4 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "93.7,460.1 93.7,480.8 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "quotedbl"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "47.6,16.4 24.9,108.8 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "84.6,17.9 60.1,145.7 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "quotedblbase"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "40.3,390.0 20.3,468.2 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "78.0,390.0 62.6,482.3 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "quotedblright"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "47.6,16.4 24.9,108.8 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "84.6,17.9 60.1,145.7 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "quoteleft"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "47.6,16.4 24.9,108.8 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "quoteright"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "47.6,16.4 32.2,108.8 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "quotesinglbase"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "40.3,390.0 20.3,468.2 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "quotesingle"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "55.7,18.9 47.0,99.6 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "underscore"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "17.7,478.4 267.9,478.4 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "euro"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 17,
    y1: 160.3,
    x2: 316.4,
    y2: 173.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 41.4,
    y1: 280.8,
    x2: 293.8,
    y2: 280.8
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "429.5,49.2 394.7,28.4 339.1,28.4 271.2,49.2 209.1,88.7 177.1,128.3 145,198 145,254.5 158.2,316.6 182.7,361.8 229.8,414.6 293.8,446.6 363.5,463.6 450.2,463.6 "
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbols);
export default __webpack_public_path__ + "static/media/symbols.2a104776028f2215f347e22d6c819811.svg";
export { ForwardRef as ReactComponent };